import {
  Dropdown,
  Table,
  Form,
  Button,
  InputGroup,
  Nav,
} from "react-bootstrap";

import DetailedIcon, {
  ExportIcon,
  FilterIcon,
  FilterTwoIcon,
  BusinessBillIcon,
  PrintIcon,
  SummaryChartIconUp,
  SummaryChartIconDown,
  SummaryCloseIcon,
  FilterCollapseIcon,
  RecieptIcon,
  PageHeaderListIcon,
  BookIcon,
  NoSelectedItemIcon,
  MoneyDollarIcon,
  EditIcon,
  DropdownEyeIcon,
  ExcelIcon,
  PDFIcon,
} from "../Icons";
import "./../../assets/scss/reports/cashbook.scss";
import { useEffect, useRef, useState } from "react";
import CachedIcon from "mdi-react/CachedIcon";
import Select from "react-select";
import useDebounce, {
  useCurrencies,
  useIsAdmin,
  useLocalStorage,
  useQueryParams,
  useScrollTop,
  useSingleAndDoubleClick,
} from "../../utils/hooks";
import { services } from "../../config";
import { queryActions, reportActions } from "../../utils/reactQueryActions";
import { useMutation, useQuery } from "react-query";
import currency from "currency.js";
import { format, parse } from "date-fns";
import ReactPaginate from "react-paginate";
import {
  customerFullName,
  defaultSelectValue,
  formatDate,
  paginationOptions,
  reactSelectTheme,
  requisitionDetailsLink,
  requisitionLink,
} from "../../utils/helpers";
import RsDateRangePicker from "../utils/RsDateRangePicker";
import queryString from "query-string";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import { useAuth } from "../../hooks/useAuth";
import { Link } from "react-router-dom";
import CustomerSelector from "../utils/CustomerSelector";
import { Popover } from "react-tiny-popover";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { lowerCase } from "lodash";
import { isEmpty } from "lodash";
import NoTableItem from "../utils/NoTableItem";
import ExpensesSelector from "../utils/ExpensesSelector";
import PageHeader from "../PageHeader";
import { useLocation, useNavigate } from "react-router-dom";
import ModalLoader from "../utils/ModalLoader";
import { toast } from "react-toastify";
import { IsPrivileged } from "../DisplayChildElement";
import { useStoreState } from "easy-peasy";
import { useMemo } from "react";
import {
  FaBox,
  FaBoxes,
  FaIndent,
  FaMoneyBill,
  FaOutdent,
} from "react-icons/fa";
import JobWareHouseIssuedItems from "./JobWarehouseIssue";
import JobWareHouseIssuedTable from "./JobWarehouseIssuedTable";
import { useDownloadExcel } from "../../hooks/useDownloadExcel";
import { CSVLink } from "react-csv";
import IncomeStatement from "../Reports/IncomeStatement";
import IncomeStatementByJob from "../Reports/IncomeStatementByJob";
import JobPOPicker from "../Jobs/JobPOPicker";
import JobMilestonePicker from "../Jobs/JobMilestonePicker";
import { act } from "react";
import ProjectedDepreciationTable from "../warehouse/stock/ProjectedDepreciationTable";
import FilledForms from "../Requisition/FilledForms";

function getMilestoneLabel({ milestoneNumber, milestones }) {
  if (!milestoneNumber || !milestones) return "";
  const milestone = milestones.find(m => m.milestoneNumber === milestoneNumber);
  return milestone ? milestone.milestone : "";
}

export default function JobIncomeStatement() {
  useScrollTop();
  const navigate = useNavigate();
  const initialFilterParams = {
    Description: "",
    AccountID: "",
    /*startDate: format(new Date(), "yyyy-MM-dd"),
    endDate: format(new Date(), "yyyy-MM-dd"),*/
    enableDateRange: true,
    jobIncomeAccountID: "",
  };

  const { backendUrl } = useAuth();
  const {
    deploymentCurrencies: currenciesOptions,
    prevailingCurrency,
  } = useCurrencies();
  const [showExpensePopover, setShowExpensePopover] = useState(false);
  const [showFilter, setShowFilter] = useLocalStorage("showFilter", true);
  const [btnSummryActive, setBtnSummaryActive] = useState(false);
  const [showMoreSummary, setShowMoreSummary] = useState(true);
  const [excelData, setExcelData] = useState([]);
  const CSVLinkRef = useRef(null);
  // fetch excel hook
  const [isfetchingExcel, fetchExcelData] = useDownloadExcel(
    excelData,
    CSVLinkRef
  );

  const [issuedWarehouseItems, setIssuedWarehouseItems] = useState({
    warehouseDetails: {},
    open: false,
    Trans_ID: "",
    contract: "",
    jobName: "",
  });
  const [issuedAllItems, setAllIssuedItems] = useState({
    open: false,
    contract: "",
    jobName: "",
  });
  const [activeButton, setActiveButton] = useState("");
  const [showFilledFormsModal, setShowFilledFormsModal] = useState(false);

  const generalSettings = useStoreState(state => state.generalSettings);
  const isAdmin = useIsAdmin();

  const close = () => {
    setShowMoreSummary(true);
    setBtnSummaryActive(false);
  };

  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 100,
    ...initialFilterParams,
    currency: "",
    convertCurrency: prevailingCurrency,
  });

  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });

  const debouncedFilterParams = useDebounce(filterParams, 500);
  useEffect(() => {
    setQueryParams({ ...queryParams, ...debouncedFilterParams });
  }, [debouncedFilterParams]);

  const fetchJournalDetailsByAccount = async queryParams => {
    // await waitFor(5000);
    let response = await fetch(
      `${backendUrl}/api/journal/job-income-statement?&${queryString.stringify(
        queryParams
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();

    return data;
  };

  const {
    data = { count: 0, journal: [] },
    refetch,
    isFetching,
    isSuccess,
  } = useQuery(
    [queryActions.JOURNAL_BY_ACCOUNT, queryParams],
    () => fetchJournalDetailsByAccount(queryParams),
    {
      keepPreviousData: true,
      enabled: Boolean(queryParams?.AccountID),
    }
  );

  const handleFilterParamsChange = e => {
    setFilterParams({
      ...filterParams,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const handleSearchQueryChange = e => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
    });
  };

  const filterByDateRange = date => {
    setFilterParams({
      ...filterParams,
      startDate: format(date[0], "yyyy-MM-dd"),
      endDate: format(date[1], "yyyy-MM-dd"),
      enableDateRange: true,
    });
  };

  const clearDateRange = () => {
    setFilterParams({
      ...filterParams,
      startDate: "",
      endDate: "",
    });
  };

  const search = () => {
    setQueryParams({
      ...queryParams,
      ...filterParams,
    });
  };

  const reset = () => {
    setFilterParams(initialFilterParams);
    setQueryParams({
      ...queryParams,
      ...initialFilterParams,
    });
  };

  const handleSelectedExpense = ({ AccountID, Description }) => {
    setFilterParams({
      ...filterParams,
      AccountID,
      Description,
    });
    setShowExpensePopover(false);
  };

  const getWarehouse = async ({ warehouseId }) => {
    let response = await fetch(
      `${backendUrl}/api/warehouse/single/${warehouseId}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const getWarehouseMutation = useMutation(payload => getWarehouse(payload), {
    onError: ({ message = "" }) => {
      toast.error(`Unable to get warehouse data, Try again.`);
    },
  });
  const openIssuedItem = data => {
    const warehouseId = data.Ref.split(" ")[0].trim();
    getWarehouseMutation.mutate(
      {
        warehouseId,
      },
      {
        onSuccess: ({ message, warehouses }) => {
          setIssuedWarehouseItems({
            warehouseDetails: {
              namewh: warehouses.W_name,
              cater: warehouses.W_Category,
              whID: warehouses.W_ID,
            },
            open: true,
            Trans_ID: data.TransID,
            contract: data.jobNumber,
            jobName: queryParams?.Description,
          });
        },
      }
    );
  };

  const currencySymbol = useMemo(() => {
    const foundCurrency = currenciesOptions.find(
      el => el.cc === filterParams.convertCurrency
    );
    return foundCurrency ? foundCurrency.symbol : "";
  }, [filterParams.convertCurrency]);

  const jobCost = useMemo(() => {
    const job = data?.job;
    if (!job || !job.jobCost) return 0;

    const sameCurrency = job.currency === filterParams.convertCurrency;
    if (sameCurrency) {
      return job.jobCost;
    }

    // Guard against invalid conversion rates
    if (!job.conversionAmountOnJobCost || job.conversionAmountOnJobCost <= 0) {
      console.warn("Invalid conversion rate for job cost");
      return job.jobCost; // or return 0, depending on your preference
    }

    // Convert to USD from any currency
    if (filterParams.convertCurrency === "USD" && job.currency !== "USD") {
      return currency(job.jobCost).divide(job.conversionAmountOnJobCost).value;
    }

    // Convert to NGN from any currency
    if (filterParams.convertCurrency === "NGN" && job.currency !== "NGN") {
      return currency(job.jobCost).multiply(job.conversionAmountOnJobCost)
        .value;
    }

    // Fallback for unsupported currency conversions
    console.warn(
      `Unsupported currency conversion: ${job.currency} to ${
        filterParams.convertCurrency
      }`
    );
    return job.jobCost;
  }, [
    data?.job, // Include the whole job object
    filterParams.convertCurrency,
  ]);

  const handleSelect = eventKey => {
    setActiveButton(eventKey);
    setFilterParams({ ...filterParams, jobIncomeAccountID: eventKey });
  };

  // download excel function
  const { limit, page, ...rest } = queryParams;
  const onDownloadExcelData = async () => {
    let exData = await fetchExcelData(
      `${backendUrl}/api/journal/job-income-statement?${queryString.stringify(
        rest
      )}`,
      "GET"
    );

    const company = exData.data?.company?.CompName;
    exData = exData.data.journal.map(row => ({
      ...row,
      DateLog: format(new Date(row.DateLog), "dd-MMM-yyyy hh:mm:ss a"),
    }));

    exData = exData.map(d => [
      d.DateLog ? format(new Date(d.DateLog), "dd MMM yyyy") : "...",
      d.AccountID,
      d.Ref,
      currency(d.Debit, {
        symbol: currencySymbol,
      }).format(),
      currency(d.Credit, {
        symbol: currencySymbol,
      }).format(),
    ]);

    const date =
      rest.startDate && rest.endDate
        ? `Date Prepared: Between ${format(
            new Date(rest.startDate),
            "E MMM d yyyy"
          )} to ${format(new Date(rest.endDate), "E MMM d yyyy")}`
        : "";

    exData = [
      [company],
      [queryParams?.AccountID],
      [queryParams?.Description],
      ["Job / Contract Report"],
      [date],
      [""],
      ["Trans Date", "Account Type", "Remark", "Debit", "Credit"],
      ...exData,
      [""],
      ["Summary"],
      [
        "Job / Contract Value",
        currency(jobCost, {
          symbol: currencySymbol,
        }).format(),
      ],
      [
        "Budget",
        data?.jobBudget?.amount
          ? currency(data?.jobBudget?.amount, {
              symbol: currencySymbol,
            }).format()
          : "...",
      ],
      [
        "Expense Variation",
        data?.jobBudget?.amount && data?.debit > data?.jobBudget?.amount
          ? currency(data?.jobBudget?.amount, {
              symbol: currencySymbol,
            })
              .subtract(data?.debit)
              .format()
          : "...",
      ],
      [
        "Revenue",
        currency(data?.revenueBalance, {
          symbol: currencySymbol,
        }).format(),
      ],
      [
        "COST OF SALES (Material Used)",
        currency(data?.materialUsedBalance, {
          symbol: currencySymbol,
        }).format(),
      ],
      [
        "Expense",
        currency(data?.expenseBalance, {
          symbol: currencySymbol,
        }).format(),
      ],
      [
        "Profit",
        currency(data?.balance, {
          symbol: currencySymbol,
        }).format(),
      ],
    ];
    // console.log(exData);
    setExcelData(exData);
  };

  // isprivileged
  return (
    <IsPrivileged roleName="Job/Contract Report">
      <main className="inner-page-outlet">
        <main className="cash-book">
          <div className="content">
            <div className="content-main">
              <div className={`filter-area ${showFilter ? "open" : "close"}`}>
                <div className="filter-header">
                  <h2>
                    <FilterTwoIcon /> Filters
                  </h2>

                  <Button
                    variant="white"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <FilterCollapseIcon />
                  </Button>
                </div>
                <div className="filter-body">
                  <Form>
                    <div className="body">
                      <Form.Group className="mb-2-5">
                        <Form.Label>Job / Contract Number</Form.Label>
                        <InputGroup>
                          <Form.Control
                            name="AccountID"
                            placeholder="Enter Job / Contract Number"
                            value={filterParams?.AccountID}
                            onChange={e => handleFilterParamsChange(e)}
                          />
                          <Popover
                            isOpen={showExpensePopover}
                            onClickOutside={() => setShowExpensePopover(false)}
                            content={() => (
                              <ExpensesSelector
                                handleSelectedExpense={handleSelectedExpense}
                                usage="chart of accounts"
                                DetailType="JOB"
                              />
                            )}
                            position="bottom"
                          >
                            <InputGroup.Text
                              onClick={() =>
                                setShowExpensePopover(!showExpensePopover)
                              }
                            >
                              <MagnifyIcon />
                            </InputGroup.Text>
                          </Popover>
                        </InputGroup>
                      </Form.Group>

                      <Form.Group className="mb-2-5">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                          name="Description"
                          value={filterParams?.Description}
                          placeholder="Enter Title"
                          onChange={e => handleFilterParamsChange(e)}
                        />
                      </Form.Group>

                      <Form.Group className="mb-2-5">
                        <Form.Label>PO Number</Form.Label>
                        <JobPOPicker
                          jobNumber={filterParams?.AccountID}
                          name="poNumber"
                          value={filterParams?.poNumber}
                          placeholder="Select PO Number"
                          onChange={selected =>
                            setFilterParams({
                              ...filterParams,
                              poNumber: selected?.value || "",
                            })
                          }
                          menuPosition="fixed"
                          menuPlacement="top"
                        />
                      </Form.Group>

                      {/* JOB MILESTONE */}
                      <Form.Group className="mb-3">
                        <Form.Label>Milestone :</Form.Label>

                        <JobMilestonePicker
                          type="text"
                          placeholder="Select Milestone"
                          name="milestone"
                          value={filterParams?.milestoneNumber}
                          onChange={selected => {
                            setFilterParams({
                              ...filterParams,
                              milestoneNumber: selected?.value || "",
                            });
                          }}
                          jobNumber={filterParams?.AccountID}
                        />
                      </Form.Group>

                      <hr className="mt-3 mb-4" />

                      <Form.Group className="">
                        <Form.Label>Date Range</Form.Label>
                        <div className="position-relative">
                          <RsDateRangePicker
                            placement="topStart"
                            value={
                              filterParams.startDate && filterParams.endDate
                                ? [
                                    parse(
                                      filterParams.startDate,
                                      "yyyy-MM-dd",
                                      new Date()
                                    ),
                                    parse(
                                      filterParams.endDate,
                                      "yyyy-MM-dd",
                                      new Date()
                                    ),
                                  ]
                                : []
                            }
                            onClean={() => clearDateRange()}
                            onOk={date => filterByDateRange(date)}
                          />
                        </div>
                      </Form.Group>
                    </div>

                    <div className="buttons rounded">
                      <Button onClick={() => reset()} variant="white">
                        Reset
                      </Button>
                      <Button onClick={() => search()} variant="primary">
                        Search
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
              <div className="content-body">
                <header className="bg-white">
                  <h1>
                    {!showFilter && (
                      <button
                        onClick={() => setShowFilter(!showFilter)}
                        className="btn filter"
                      >
                        <FilterTwoIcon />
                      </button>
                    )}
                    Job/Contract Report
                    <button
                      title="Refresh"
                      onClick={() => refetch()}
                      className="btn text-primary"
                    >
                      <CachedIcon />
                    </button>
                  </h1>
                  <h2 className="m-0 col-4 text-wrap">
                    {queryParams?.Description}
                  </h2>
                  <div className="actions text-nowrap">
                    <Form.Group className="d-flex gap-2 align-items-center z-10 text-nowrap">
                      <Form.Label className="fw-5">Filter By:</Form.Label>
                      <Select
                        classNamePrefix="form-select"
                        placeholder="All Currencies"
                        isSearchable={true}
                        options={currenciesOptions}
                        value={currenciesOptions.find(
                          el => el.value == filterParams.currency
                        )}
                        onChange={selected =>
                          setFilterParams({
                            ...filterParams,
                            page: 1,
                            currency: selected?.value,
                          })
                        }
                        isClearable={true}
                        menuPosition="fixed"
                      />
                    </Form.Group>

                    <Form.Group className="d-flex gap-2 align-items-center z-10 text-nowrap">
                      <Form.Label className="fw-5">Report In:</Form.Label>
                      <Select
                        classNamePrefix="form-select"
                        placeholder="Select Currency"
                        isSearchable={true}
                        options={currenciesOptions}
                        value={currenciesOptions.find(
                          el => el.value === filterParams.convertCurrency
                        )}
                        onChange={({ value }) =>
                          setFilterParams({
                            ...filterParams,
                            page: 1,
                            convertCurrency: value,
                          })
                        }
                        menuPosition="fixed"
                      />
                    </Form.Group>

                    <CSVLink
                      className="btn print d-none"
                      filename={`Job / Contract Report for ${
                        queryParams?.AccountID
                      } (${format(new Date(), "dd-MMM-yyyy hh:mm:ss a")}).csv`}
                      data={excelData}
                      ref={CSVLinkRef}
                    />
                    <Dropdown>
                      <Dropdown.Toggle
                        variant=""
                        className="btn print"
                        disabled={
                          isfetchingExcel ||
                          filterParams?.jobIncomeAccountID === "Summary"
                        }
                        bsPrefix=""
                        title="Export"
                      >
                        <ExportIcon color="#008000" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        popperConfig={{
                          strategy: "fixed",
                        }}
                        renderOnMount
                        className="text-center"
                      >
                        <Dropdown.Item
                          as="div"
                          onClick={onDownloadExcelData}
                          className="p-cursor"
                        >
                          Excel <ExcelIcon color="#008000" />
                        </Dropdown.Item>
                        <Dropdown.Item as="div">
                          <a
                            href={`${backendUrl}/api/journal/pdf/job-income-statement?${queryString.stringify(
                              {
                                ...rest,
                                currencySymbol,
                                jobCost,
                              }
                            )}`}
                            target="_blank"
                          >
                            PDF <PDFIcon color="#ff0000" />
                          </a>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown>
                      <Dropdown.Toggle
                        variant=""
                        className="btn print"
                        bsPrefix=""
                      >
                        <DotsVerticalIcon />
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        popperConfig={{
                          strategy: "fixed",
                        }}
                        renderOnMount
                        className="dropdown-with-icons"
                      >
                        <>
                          <Dropdown.Item
                            as="button"
                            onClick={() => setShowFilledFormsModal(true)}
                          >
                            Filled Forms
                          </Dropdown.Item>

                          <Dropdown.Item
                            as="button"
                            onClick={() => setBtnSummaryActive(true)}
                          >
                            Summary
                          </Dropdown.Item>
                        </>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </header>

                <div className="px-md-4 py-0">
                  <div className="border">
                    <Nav
                      justify
                      variant="underline"
                      className="fw-5 nav-tab-override border-bottom"
                      defaultActiveKey={filterParams.jobIncomeAccountID}
                      onSelect={handleSelect}
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="" className={`nav-link ga-nav-tab`}>
                          <FaBox />
                          &nbsp; All
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          title="INCOME"
                          eventKey="INCOME"
                          className={`nav-link ga-nav-tab`}
                        >
                          <FaIndent />
                          &nbsp; Revenue
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          title="COST OF SALES"
                          eventKey="COST OF SALES"
                          className={`nav-link ga-nav-tab`}
                        >
                          <FaBoxes />
                          &nbsp; Material used
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          title="EXPENSES"
                          eventKey="EXPENSES"
                          className={`nav-link ga-nav-tab`}
                        >
                          <FaOutdent />
                          &nbsp; Expense
                        </Nav.Link>
                      </Nav.Item>

                      <Nav.Item>
                        <Nav.Link
                          title="Summary"
                          eventKey="Summary"
                          className={`nav-link ga-nav-tab text-nowrap`}
                        >
                          <FaIndent />
                          &nbsp; Project Income Summary
                        </Nav.Link>
                      </Nav.Item>

                      <Nav.Item>
                        <Nav.Link
                          title="Depreciation"
                          eventKey="Depreciation"
                          className={`nav-link ga-nav-tab`}
                        >
                          <FaIndent />
                          &nbsp; Depreciation
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>

                    {activeButton === "COST OF SALES" &&
                    filterParams?.AccountID !== "" ? (
                      <div className="m-3">
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() =>
                            setAllIssuedItems({
                              open: true,
                              contract: filterParams?.AccountID,
                              jobName: filterParams?.Description,
                            })
                          }
                        >
                          Show Items
                        </button>
                      </div>
                    ) : null}

                    {filterParams?.jobIncomeAccountID !== "Summary" &&
                    activeButton !== "Depreciation" ? (
                      <>
                        <div className="">
                          <Table
                            responsive
                            borderless
                            striped
                            className="product-table mb-0"
                          >
                            <thead>
                              <tr>
                                <th />
                                <th>Trans Date</th>
                                <th>Account Type</th>
                                <th>Remark</th>
                                <th>Debit</th>
                                <th>Credit</th>
                                <th>PO Number</th>
                                <th>Milestone</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.journal.map((el, index) => (
                                <tr key={index}>
                                  <td>
                                    <Dropdown>
                                      <Dropdown.Toggle
                                        variant=""
                                        className="bg-white border-0"
                                        bsPrefix="print more"
                                      >
                                        <DotsVerticalIcon />
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu
                                        popperConfig={{
                                          strategy: "fixed",
                                        }}
                                        renderOnMount
                                        className="dropdown-with-icons"
                                      >
                                        <>
                                          {isAdmin ? (
                                            <Dropdown.Item as="div">
                                              <Link
                                                to={`/journal-entry/edit/${
                                                  el.TransID
                                                }`}
                                                state={{
                                                  jobNumber:
                                                    el?.jobNumber ||
                                                    filterParams?.AccountID,
                                                }}
                                              >
                                                <EditIcon />
                                                Edit
                                              </Link>
                                            </Dropdown.Item>
                                          ) : null}
                                        </>{" "}
                                        {el.AccountID.includes("INCOME") ? (
                                          <Dropdown.Item
                                            as="button"
                                            onClick={() =>
                                              navigate(
                                                `/inventory-for-sales/manage-transaction`,
                                                {
                                                  state: {
                                                    TransactionID: el.TransID,
                                                  },
                                                }
                                              )
                                            }
                                          >
                                            <DropdownEyeIcon className="text-light" />
                                            Open Transaction
                                          </Dropdown.Item>
                                        ) : null}
                                        {el.Ref.includes("ISSUE ITEM") ||
                                        el.Ref.includes("RETURN ITEM") ? (
                                          <Dropdown.Item
                                            as="button"
                                            onClick={() => openIssuedItem(el)}
                                          >
                                            <DropdownEyeIcon className="text-light" />
                                            Open Issued Items
                                          </Dropdown.Item>
                                        ) : el.AccountID.includes(
                                            "EXPENSES"
                                          ) ? (
                                          <Dropdown.Item
                                            as="button"
                                            onClick={() =>
                                              navigate(
                                                `/reports/expenses?ExpID=${
                                                  el?.ExpID
                                                }&startDate=&endDate=`
                                              )
                                            }
                                          >
                                            <DropdownEyeIcon className="text-light" />
                                            Open Expense
                                          </Dropdown.Item>
                                        ) : null}
                                        {el.Ref.includes("REQ") ? (
                                          <Dropdown.Item as="div">
                                            <Link
                                              to={requisitionLink(
                                                el.Ref?.match(/REQ\d+/)?.[0]
                                              )}
                                              target="_blank"
                                            >
                                              <BookIcon />
                                              View Requisition
                                            </Link>
                                          </Dropdown.Item>
                                        ) : null}
                                      </Dropdown.Menu>{" "}
                                    </Dropdown>
                                  </td>
                                  <td className="text-nowrap">
                                    {el.DateLog
                                      ? formatDate(
                                          new Date(el.DateLog),
                                          "dd MMM yyyy"
                                        )
                                      : "..."}
                                  </td>
                                  <td>{el.AccountID}</td>
                                  <td>{el.Ref || "..."}</td>
                                  <td>
                                    {currency(el.Debit, {
                                      symbol: currencySymbol,
                                    }).format()}
                                  </td>
                                  <td>
                                    {currency(el.Credit, {
                                      symbol: currencySymbol,
                                    }).format()}
                                  </td>
                                  <td>{el.poNumber}</td>
                                  <td>
                                    {getMilestoneLabel({
                                      milestoneNumber: el.milestoneNumber,
                                      milestones: data?.jobMilestones,
                                    })}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </>
                    ) : filterParams?.AccountID &&
                      activeButton !== "Depreciation" ? (
                      <IncomeStatementByJob
                        filterParams={filterParams}
                        setFilterParams={setFilterParams}
                        queryParams={queryParams}
                        setQueryParams={setQueryParams}
                        jobNumber={filterParams?.AccountID}
                        poNumber={filterParams?.poNumber}
                        hideZeroBalance={true}
                      />
                    ) : null}

                    {activeButton === "Depreciation" &&
                    filterParams?.AccountID !== "" ? (
                      <ProjectedDepreciationTable
                        jobNumber={filterParams?.AccountID}
                        contracts={filterParams?.poNumber}
                        startDate={filterParams?.startDate}
                        endDate={filterParams?.endDate}
                      />
                    ) : null}

                    <div className="mb-4">
                      {!isFetching &&
                      isSuccess &&
                      isEmpty(data?.journal) &&
                      filterParams?.jobIncomeAccountID !== "Summary" &&
                      activeButton !== "Depreciation" ? (
                        <NoTableItem queryParams={queryParams} />
                      ) : isEmpty(queryParams?.AccountID) ? (
                        <div className="d-flex flex-column align-items-center justify-content-center">
                          <NoTableItem queryParams={{}} />
                          <Button
                            onClick={() => {
                              setTimeout(() => {
                                setShowExpensePopover(true);
                              }, 20);
                            }}
                            className="text-center"
                            variant="outline-primary"
                          >
                            Select a Job
                          </Button>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between px-3 align-items-center pagination">
                  <div className="pagination_left">
                    <p className="m-0 p-0">Show</p>
                    <select
                      value={queryParams.limit}
                      name="limit"
                      className="form-select "
                      onChange={e => handleSearchQueryChange(e)}
                      disabled={activeButton == "Summary"}
                    >
                      <option value="10">10 rows</option>
                      <option value="20">20 rows</option>
                      <option value="30">30 rows</option>
                      <option value="40">40 rows</option>
                      <option value="50">50 rows</option>
                      <option value="100">100 rows</option>
                    </select>
                  </div>

                  <ReactPaginate
                    {...paginationOptions}
                    pageCount={Math.ceil(data.count / queryParams.limit)}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={0}
                    onPageChange={({ selected }) => {
                      document.body.scrollTop = document.documentElement.scrollTop = 0;
                      setQueryParams({
                        ...queryParams,
                        page: selected + 1,
                      });
                    }}
                    forcePage={queryParams.page - 1}
                  />
                </div>

                <div
                  className={`${
                    btnSummryActive
                      ? `summaryNew border-top open`
                      : `summaryNew border-top`
                  } ${
                    filterParams?.jobIncomeAccountID === "Summary"
                      ? "d-none"
                      : ""
                  }`}
                >
                  <div className="summaryHeader">
                    <h2>Summary</h2>
                    {btnSummryActive && (
                      <button onClick={() => close()} className="btn p-0">
                        <SummaryCloseIcon />
                      </button>
                    )}
                  </div>

                  <div className="gridCont">
                    <div className="gridChild gridChildBorderLeftDarkPurple ">
                      <div className="gridChildLeft">
                        <p
                          className="gridChld1"
                          title={`${data?.job?.currency} _ ${
                            data?.job?.jobCost
                          }`}
                        >
                          {currency(jobCost, {
                            symbol: currencySymbol,
                          }).format()}
                        </p>
                        <p className="gridChld2">Job \ Contract Value</p>
                      </div>

                      <div className="gridChildRight">
                        <SummaryChartIconUp />
                        <p>5%</p>
                      </div>
                    </div>

                    <div className="gridChild gridChildBorderLeftLightYellow">
                      <div className="gridChildLeft">
                        <p className="gridChld1">
                          {data?.jobBudget?.amount
                            ? currency(data?.jobBudget?.amount, {
                                symbol: currencySymbol,
                              }).format()
                            : "..."}
                        </p>
                        <p className="gridChld2">Budget</p>
                      </div>

                      <div className="gridChildRight">
                        <SummaryChartIconDown />
                        <p>5%</p>
                      </div>
                    </div>

                    <div className="gridChild gridChildBorderLeftViolet">
                      <div className="gridChildLeft">
                        <p className="gridChld1">
                          {data?.jobBudget?.amount &&
                          data?.debit > data?.jobBudget?.amount
                            ? currency(data?.jobBudget?.amount, {
                                symbol: currencySymbol,
                              })
                                .subtract(data?.debit)
                                .format()
                            : "..."}
                        </p>
                        <p className="gridChld2">Expense Variation</p>
                      </div>

                      <div className="gridChildRight">
                        <SummaryChartIconUp />
                        <p>5%</p>
                      </div>
                    </div>

                    <br />

                    <div className="gridChild gridChildBorderLeftOrange">
                      <div className="gridChildLeft">
                        <p className="gridChld1">
                          {currency(data?.revenueBalance, {
                            symbol: currencySymbol,
                          }).format()}
                        </p>
                        <p className="gridChld2">Revenue</p>
                      </div>

                      <div className="gridChildRight">
                        <SummaryChartIconUp />
                        <p>5%</p>
                      </div>
                    </div>

                    <div className="gridChild gridChildBorderLeftBlue">
                      <div className="gridChildLeft">
                        <p className="gridChld1">
                          {currency(data?.materialUsedBalance, {
                            symbol: currencySymbol,
                          }).format()}
                        </p>
                        <p className="gridChld2">
                          COST OF SALES (Material Used)
                        </p>
                      </div>

                      <div className="gridChildRight">
                        <SummaryChartIconUp />
                        <p>5%</p>
                      </div>
                    </div>

                    <div className="gridChild gridChildBorderLeftDarkerGreen">
                      <div className="gridChildLeft">
                        <p className="gridChld1">
                          {currency(data?.expenseBalance, {
                            symbol: currencySymbol,
                          }).format()}
                        </p>
                        <p className="gridChld2">Expense</p>
                      </div>

                      <div className="gridChildRight">
                        <SummaryChartIconUp />
                        <p>5%</p>
                      </div>
                    </div>

                    <div className="gridChild gridChildBorderLeftBrown">
                      <div className="gridChildLeft">
                        <p className="gridChld1">
                          {currency(data?.balance, {
                            symbol: currencySymbol,
                          }).format()}
                        </p>
                        <p className="gridChld2">Profit</p>
                      </div>

                      <div className="gridChildRight">
                        <SummaryChartIconDown />
                        <p>5%</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        {/*  */}
        {issuedWarehouseItems.open ? (
          <JobWareHouseIssuedItems
            warehouseLocal={issuedWarehouseItems.warehouseDetails}
            onHide={() =>
              setIssuedWarehouseItems(el => ({ ...el, open: false }))
            }
            show={issuedWarehouseItems.open}
            Trans_ID={issuedWarehouseItems.Trans_ID}
            contracts={issuedWarehouseItems.contract}
            jobName={issuedWarehouseItems.jobName}
          />
        ) : null}

        {/*  */}
        {issuedAllItems.open ? (
          <JobWareHouseIssuedTable
            show={issuedAllItems.open}
            onHide={() => setAllIssuedItems(el => ({ ...el, open: false }))}
            contracts={issuedAllItems.contract}
            jobName={issuedAllItems.jobName}
          />
        ) : null}

        {showFilledFormsModal ? (
          <FilledForms
            form={""}
            setSelectedForm={() => {}}
            setShowFilledFormsModal={setShowFilledFormsModal}
            jobNumber={filterParams?.AccountID}
          />
        ) : null}

        <ModalLoader show={getWarehouseMutation.isLoading} />
      </main>
    </IsPrivileged>
  );
}
